var _path, _path2, _path3, _path4, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 15,
    viewBox: "0 0 29 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hinava_random_uuid_24617250186710418997586386513223308061)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hinava_random_uuid_176257095215788515721782803925494185146",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 29,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4352 0H4.80508C2.49379 0 0.620117 1.567 0.620117 3.5V11.5C0.620117 13.433 2.49379 15 4.80508 15H24.4352C26.7464 15 28.6201 13.433 28.6201 11.5V3.5C28.6201 1.567 26.7464 0 24.4352 0ZM24.4352 1C26.0852 1 27.4244 2.12 27.4244 3.5V11.5C27.4244 12.88 26.0852 14 24.4352 14H4.80508C3.15501 14 1.81582 12.88 1.81582 11.5V3.5C1.81582 2.12 3.15501 1 4.80508 1H24.4352Z",
    fill: "url(#hinava_random_uuid_264778311173274384908734211226296143036)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0707 3.98486H7.10144V5.80566H10.5765V7.18066H7.10144V10.5H5.45789V2.59375H11.0707V3.98486Z",
    fill: "#C76D6D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2792 5.2793C12.6838 4.76367 13.3785 4.50586 14.3632 4.50586C15.0041 4.50586 15.5734 4.63298 16.0712 4.88721C16.5689 5.14144 16.8177 5.62126 16.8177 6.32666V9.01221C16.8177 9.1984 16.8213 9.42399 16.8285 9.68896C16.8392 9.88949 16.8697 10.0256 16.9198 10.0972C16.9699 10.1688 17.0451 10.2279 17.1454 10.2744V10.5H15.4803C15.4338 10.3818 15.4016 10.2708 15.3837 10.167C15.3658 10.0632 15.3514 9.94499 15.3407 9.8125C15.1294 10.0417 14.8859 10.2368 14.6102 10.3979C14.2808 10.5877 13.9084 10.6826 13.493 10.6826C12.9631 10.6826 12.5245 10.5322 12.1771 10.2314C11.8334 9.92708 11.6615 9.4974 11.6615 8.94238C11.6615 8.22266 11.939 7.70166 12.494 7.37939C12.7984 7.20394 13.246 7.07861 13.8368 7.00342L14.3578 6.93896C14.6407 6.90316 14.843 6.8584 14.9647 6.80469C15.1831 6.71159 15.2924 6.56657 15.2924 6.36963C15.2924 6.12972 15.2082 5.96501 15.0399 5.87549C14.8752 5.78239 14.6317 5.73584 14.3094 5.73584C13.9478 5.73584 13.6918 5.82536 13.5414 6.00439C13.434 6.13688 13.3623 6.31592 13.3265 6.5415H11.8495C11.8817 6.02946 12.0249 5.60872 12.2792 5.2793ZM13.4178 9.39355C13.5611 9.51172 13.7365 9.5708 13.9442 9.5708C14.2736 9.5708 14.5762 9.47412 14.8519 9.28076C15.1312 9.0874 15.2762 8.7347 15.287 8.22266V7.65332C15.1903 7.71419 15.0918 7.76432 14.9916 7.80371C14.8949 7.83952 14.7606 7.87354 14.5887 7.90576L14.245 7.97021C13.9227 8.02751 13.6918 8.09733 13.5521 8.17969C13.3158 8.31934 13.1976 8.53597 13.1976 8.82959C13.1976 9.09098 13.271 9.27897 13.4178 9.39355Z",
    fill: "#C76D6D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9374 5.77881C20.4182 5.77881 20.0619 5.99902 19.8685 6.43945C19.7683 6.6722 19.7181 6.9694 19.7181 7.33105V10.5H18.1927V4.65625H19.6698V5.51025C19.8667 5.20947 20.0529 4.99284 20.2284 4.86035C20.5435 4.62402 20.9427 4.50586 21.4261 4.50586C22.0313 4.50586 22.5254 4.6652 22.9086 4.98389C23.2953 5.29899 23.4886 5.82357 23.4886 6.55762V10.5H21.9203V6.93896C21.9203 6.63102 21.8791 6.39469 21.7968 6.22998C21.6464 5.9292 21.3599 5.77881 20.9374 5.77881Z",
    fill: "#C76D6D"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#hinava_random_uuid_176257095215788515721782803925494185146)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.620117 0H28.6201V15H0.620117V0Z",
    fill: "url(#hinava_random_uuid_53923852163720575692545797825112514308)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_264778311173274384908734211226296143036",
    x1: 4.1667,
    y1: 5.82435,
    x2: 27.3607,
    y2: 20.5696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49FFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ADCAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_53923852163720575692545797825112514308",
    x1: 14.6201,
    y1: 4.9269,
    x2: 14.6201,
    y2: 13.6191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hinava_random_uuid_24617250186710418997586386513223308061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 15,
    fill: "white",
    transform: "translate(0.620117)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFan);
export default __webpack_public_path__ + "static/media/fan.37caf482347b1856e1f29618713522de.svg";
export { ForwardRef as ReactComponent };